import forge from 'node-forge'

/**
 * 密码加密
 * @param data
 * @param key
 * @returns
 */
export const encrypt = (data: string, key: string): string => {
  // 加载公钥
  const publicKey = forge.pki.publicKeyFromPem(key)

  // 创建一个随机的 OAEP 填充器
  const md = forge.md.sha256.create()
  const mgf = forge.md.sha1.create()

  // 加密数据
  const encrypted = publicKey.encrypt(data, 'RSA-OAEP', {
    md,
    mgf
  })

  return btoa(encrypted) // 使用 Base64 编码加密后的数据以便于传输
}
